import { useState } from "react";
import clsx from "clsx";
import { IconButton, CircularProgress, Tooltip } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { NotificationAvatar } from "./NotificationAvatar";
import { NotificationContent } from "./NotificationContent";
import { NotificationActions } from "./NotificationActions";
import styles from "./styles.module.scss";

export function NotificationItem({
  notification,
  onAction,
  onRead,
  compact = false,
}) {
  const [isMarking, setIsMarking] = useState(false);
  const {
    id,
    avatar,
    icon,
    mediaAlt,
    seed,
    message,
    time,
    actions,
    isRead,
    kind,
  } = notification;

  const handleRead = async (event) => {
    event.stopPropagation();
    if (isMarking || isRead) return;

    setIsMarking(true);
    try {
      await onRead?.(id);
    } finally {
      setIsMarking(false);
    }
  };

  return (
    <div
      className={clsx(
        styles.notificationItem,
        !isRead && styles.unread,
        compact && styles.compact,
      )}
    >
      <NotificationAvatar
        avatar={avatar}
        icon={icon}
        kind={kind}
        seed={seed}
        alt={mediaAlt || seed}
      />
      <div className={styles.notificationBody}>
        <NotificationContent
          message={message}
          time={time}
          isRead={isRead}
          compact={compact}
        />
        {actions?.length > 0 && (
          <NotificationActions
            actions={actions}
            onAction={onAction}
            compact={compact}
          />
        )}
      </div>
      {onRead && (
        <div className={styles.markReadSlot}>
          {!isRead && (
            <Tooltip title="Mark as read">
              <span>
                <IconButton
                  size="small"
                  onClick={handleRead}
                  disabled={isMarking}
                  className={styles.markReadBtn}
                  aria-label="Mark notification as read"
                >
                  {isMarking ? (
                    <CircularProgress size={16} />
                  ) : (
                    <DoneAllIcon fontSize="small" />
                  )}
                </IconButton>
              </span>
            </Tooltip>
          )}
        </div>
      )}
    </div>
  );
}
